import { useMutation, useQuery } from "react-query";
import { stringifyUrl } from "query-string";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useAvailableJobTypes = (config) =>
  useQuery({
    ...config,
    queryKey: ["available-job-types"],
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/job-types/available-by-user`,
        signal,
      }),
  });

export const useFetchSelectedJobTypesForUser = (userId, enabled = true, onlySelected = undefined) =>
  useQuery({
    queryKey: ["selected-job-types-for-user", userId],
    enabled,
    queryFn: ({ signal }) =>
      fetch({
        url: stringifyUrl({
          url: `${Angie.api_url}/users/${userId}/available-job-types`,
          query: { only_selected: onlySelected },
        }),
        signal,
      }),
  });

export const useUpdateAvailableJobTypesForUser = () => {
  return useMutation({
    mutationFn: (data) => {
      if (data.userId) {
        return fetch({
          url: `${Angie.api_url}/users/${data.userId}/available-job-types`,
          method: "PUT",
          body: { job_type_ids: data.job_type_ids },
        });
      }
    },
  });
};
